
// /*
// Want to customize your button? visit our documentation page:
// https://login.equalweb.com/custom-button
// */
window.interdeal = {
    get sitekey (){ return "21d8f312777c51fe176980dc507c347e"} ,
    get domains(){
        return {
            "js": "https://cdn.equalweb.com/",
            "acc": "https://access.equalweb.com/"
        }
    },
    "Position": "left",
    "Menulang": "NL",
    "draggable": true,
    "hideBtn": true,
    "btnStyle": {
        "vPosition": [
            "80%",
            "80%"
        ],
        "margin": [
            "0",
            "0"
        ],
        "scale": [
            "0.5",
            "0.5"
        ],
        "color": {
            "main": "#120b09",
            "second": "#ffffff"
        },
        "icon": {
            "outline": false,
            "outlineColor": "#ffffff",
            "type":  11 ,
            "shape": "circle"
        }
    },
                                  
};

(function(doc, head, body){
    var coreCall             = doc.createElement('script');
    coreCall.src             = interdeal.domains.js + 'core/5.2.0/accessibility.js';
    coreCall.defer           = true;
    coreCall.integrity       = 'sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ==';
    coreCall.crossOrigin     = 'anonymous';
    coreCall.setAttribute('data-cfasync', true );
    body? body.appendChild(coreCall) : head.appendChild(coreCall);
})(document, document.head, document.body);